import { Button } from "@mui/material";
import { useAppServices } from "hook/services";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PopUp from "./Component/PopUp";
import { useAgencyInfo } from "context/agency";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import nextIcon from "../../../../../assets/themeIcons/next.svg";
import previousIcon from "../../../../../assets/themeIcons/previous.svg";
import toast from "react-hot-toast";

function ClaimRequest({ type, onLoad }) {
  const [data, setData] = useState([]);
  const AppService = useAppServices();
  const [open, setOpen] = useState(false);
  const [claimData, setClaimData] = useState({});
  const [loading, setLoading] = useState(null);
  const [agency] = useAgencyInfo();
  const [filteredDatas, setFilteredData] = useState([]);
  const [tab, setTab] = useState("pending");
  const getClaimeBusiness = async () => {
    const { response } = await AppService.claim_business.Get({
      query: `agency_id=${agency?._id}&request_type=${type}`,
    });
    if (response) {
      setData(response?.data);
    }
  };
  useEffect(() => {
    getClaimeBusiness();
  }, []);

  useEffect(() => {
    if (tab === "pending") {
      setFilteredData(data.filter((item) => item?.status === "pending"));
    } else {
      setFilteredData(
        data.filter((item) => item?.status === "approved" || item?.status === "rejected")
      );
    }
  }, [tab, data]);

  if (!Array.isArray(data)) {
    return <p className="text-center">No record found ...</p>;
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const itemsPerPage = 10; // Number of items per page

  // Filter data based on the search query
  const filteredData = filteredDatas.filter((item) =>
    item.business_name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const maxButtonsToShow = 5; // Number of pagination buttons to display at a time

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  console.log(currentItems, "currentItems");

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Calculate start and end of pagination buttons
  const startPage = Math.max(currentPage - Math.floor(maxButtonsToShow / 2), 1);
  const endPage = Math.min(startPage + maxButtonsToShow - 1, totalPages);

  const viewClaim = (requestData) => {
    setClaimData(requestData);
    setOpen(true);
  };

  const statusUpdate = async (status, id) => {
    setLoading(status);
    const payload = {
      status: status,
      _id: id,
    };
    const { response } = await AppService.claim_business.update({ payload });
    if (response) {
      getClaimeBusiness();
      setOpen(false);
      console.log("response claim update");

      setTimeout(() => {
        onLoad();
      }, 2000);

      toast.success(response?.message);
    } else {
      toast.error("Error while updating claim");
    }
    setLoading(null);
  };

  const tableTHStyles = {
    fontFamily: "Poppins",
    fontWeight: 600,
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <div style={{ display: "flex", gap: "30px" }}>
            <p
              style={{
                fontSize: "1.5rem",
                color: "black",
                fontWeight: tab === "pending" ? "bold" : "",
                cursor: "pointer",
              }}
              onClick={() => setTab("pending")}
            >
              Pending Requests
            </p>
            <p
              style={{
                fontSize: "1.5rem",
                color: "black",
                fontWeight: tab === "closed" ? "bold" : "",
                cursor: "pointer",
              }}
              onClick={() => setTab("closed")}
            >
              Closed Requests
            </p>
          </div>
        </div>

        <div
          style={{
            position: "relative",
            marginBottom: "20px",
            display: "flex",
            width: "30%",
            float: "right",
          }}
        >
          <div style={{ position: "absolute", left: "10px", top: "20px" }}>
            <svg
              width="25"
              height="25"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_282_92)">
                <path
                  d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                  fill="#E5E5E5"
                />
              </g>
              <defs>
                <clipPath id="clip0_282_92">
                  <rect width="15" height="15" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search by name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              padding: "30px 45px",
              width: "100%",
              fontSize: "18px",
              boxSizing: "border-box",
              border: "1px solid #ccc",
              borderRadius: "5px",
            }}
          />
        </div>
      </div>

      <table className="table w-100" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#F7F7F7", borderRadius: "18px" }}>
            <th
              className="p-20-px text-left"
              style={{
                ...tableTHStyles,
                borderBottomLeftRadius: "18px",
                borderTopLeftRadius: "18px",
              }}
            >
              User Name
            </th>
            <th className="p-20-px text-left" style={tableTHStyles}>
              Business Name
            </th>
            <th className="p-20-px text-left" style={tableTHStyles}>
              Phone
            </th>
            <th className="p-20-px text-left" style={tableTHStyles}>
              Address
            </th>
            <th className="p-20-px text-left" style={tableTHStyles}>
              Status
            </th>
            <th className="p-20-px text-left" style={tableTHStyles}>
              Date
            </th>
            {tab === "pending" && (
              <th
                className="p-20-px text-left"
                style={{
                  ...tableTHStyles,
                  borderBottomRightRadius: "18px",
                  borderTopRightRadius: "18px",
                }}
              >
                Action
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {currentItems?.length > 0 ? (
            currentItems?.map((item, index) => (
              <tr key={index} style={{ cursor: "pointer", borderBottom: "1px solid #DDDDDD" }}>
                <td className="p-20-px">{item?.first_name}</td>
                <td className="p-20-px">{item?.business_name}</td>
                <td className="p-20-px">{item?.phone}</td>
                <td className="p-20-px">
                  {item?.address}
                  {item?.country && `, ${item.country}`}
                  {item?.state && `, ${item.state}`}
                  {item?.city && `, ${item.city}`}
                  {item?.postalCode && `, ${item.postalCode}`}
                </td>
                <td className="p-20-px" style={{ textTransform: "capitalize" }}>
                  {item.status}
                </td>
                <td className="p-20-px">
                  {new Date(item?.createdAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </td>
                <td className="p-20-px text-right">
                  {item.status === "withdraw" ? (
                    <Button
                      disabled
                      type="button"
                      variant="contained"
                      style={{ background: "transparent", boxShadow: "none" }}
                    >
                      <img width={20} src={editIcon} alt="edit" />
                    </Button>
                  ) : (
                    tab === "pending" && (
                      <Button
                        type="button"
                        variant="contained"
                        style={{ background: "transparent", boxShadow: "none" }}
                        onClick={() => viewClaim(item)}
                      >
                        <img width={20} src={editIcon} alt="edit" />
                      </Button>
                    )
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8} className="text-center">
                No accounts found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          style={{
            padding: "8px 16px",
            margin: "0 5px",
            backgroundColor: "white",
            color: "black",
            border: "none",
            borderRadius: "100px",
            boxShadow: "0px 1px 4px 0px #181A2012",
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
            opacity: currentPage === 1 ? 0.6 : 1,
          }}
        >
          <img src={previousIcon} />
        </button>

        {[...Array(endPage - startPage + 1)].map((_, index) => {
          const pageNumber = startPage + index;
          return (
            <button
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              style={{
                padding: "8px 16px",
                margin: "0 5px",
                backgroundColor: pageNumber === currentPage ? "#EB6753" : "white",
                color: pageNumber === currentPage ? "white" : "black",
                border: "none",
                borderRadius: "100px",
                cursor: "pointer",
              }}
            >
              {pageNumber}
            </button>
          );
        })}

        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          style={{
            padding: "8px 16px",
            margin: "0 5px",
            backgroundColor: "white",
            color: "black",
            border: "none",
            boxShadow: "0px 1px 4px 0px #181A2012",
            borderRadius: "4px",
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            opacity: currentPage === totalPages ? 0.6 : 1,
          }}
        >
          <img src={nextIcon} />
        </button>
      </div>

      <PopUp open={open} handleClose={() => setOpen(false)} title="Claim Request">
        <div>
          {/* table */}
          <table style={{ width: "100%" }}>
            <tr>
              <td>First Name</td>
              <td>
                <b>{claimData?.first_name}</b>
              </td>
            </tr>
            <tr>
              <td>Last Name</td>
              <td>
                <b>{claimData?.last_name}</b>
              </td>
            </tr>
            <tr>
              <td>Email</td>
              <td>
                <b>{claimData?.email}</b>
              </td>
            </tr>
            <tr>
              <td>Phone</td>
              <td>
                <b>{claimData?.phone}</b>
              </td>
            </tr>
            <tr>
              <td>Business Name</td>
              <td>
                <b>{claimData?.business_name}</b>
              </td>
            </tr>
            {/* <tr>
              <td>Business Reference</td>
              <td>
                <b>{claimData?.business_reference}</b>
              </td>
            </tr> */}
            <tr>
              <td>Address</td>
              <td>
                <b>{claimData?.address}</b>
              </td>
            </tr>
            <tr>
              <td>Role</td>
              <td>
                <b>{claimData?.role}</b>
              </td>
            </tr>
            {/* <tr>
              <td>Reason</td>
              <td>
                <b>{claimData?.reason}</b>
              </td>
            </tr> */}
            <tr>
              <td>Proof</td>
              <td>
                {claimData?.proof ? (
                  <a href={claimData?.proof} download>
                    Download
                  </a>
                ) : (
                  "No proof"
                )}
              </td>
            </tr>
            <tr>
              <td>Status</td>
              <td>
                <b>{claimData?.status}</b>
              </td>
            </tr>
          </table>
        </div>
        {/* button approve or cencel */}
        <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
          <Button
            type="button"
            variant="contained"
            style={{ color: "#fff", backgroundColor: "#000" }}
            disabled={loading !== null}
            onClick={() => statusUpdate("approved", claimData?._id)}
          >
            {loading === "approved" ? "Loading..." : "Approve"}
          </Button>

          <Button
            type="button"
            disabled={loading !== null}
            variant="contained"
            style={{ color: "#fff", backgroundColor: "#000" }}
            onClick={() => statusUpdate("rejected", claimData?._id)}
          >
            {loading === "rejected" ? "Loading..." : "Reject"}
          </Button>
        </div>
      </PopUp>
    </>
  );
}

export default ClaimRequest;
